import {Divider} from "antd"
import React, {useEffect, useRef, useState} from "react"
import Head from "../../components/Head"
import Button from "../../components/UI/Button"
import CheckboxGroup from "../../components/UI/CheckboxGroup"
import Input from "../../components/UI/Input"
import SelectInput from "../../components/UI/SelectInput"
import userStatus from "../../utils/userStatus"
import {useNavigate, useParams} from 'react-router-dom'
import {getRolesList} from "../../services/roles"
import SmartSearch from "../../components/UI/SmartSearch"
import {createOrUpdateUser, getAffiliationOptions, getUserById} from "../../services/users"
import {onlySpaces, validateEmail, validatePhone} from "../../utils/formValidation"
import {notificationError} from "../../services/notification"
import Radio from "../../components/UI/Radio"
import CancelButton from "../../components/CancelButton"
import {InputMode} from "../../enums/inputTypeEnum"
import {onlyNumbersAsString} from "../../utils/stringUtils";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

function NewAccount() {
  const history = useNavigate()
  const {id} = useParams<{id: string}>()
  let isStarting = false;
  const [form, setForm] = useState<any>({
    affiliationLevel: '',
    firstName: '',
    middleName: '',
    lastName: '',
    status: userStatus.active,
    email: '',
    encryptedPassword: '',
    roles: [],
    company: '',
  })
  const [roles, setRoles] = useState([])
  const [phone, setPhone] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [validSearch, setValidSearch] = useState(false)
  const [changeAffiliation, setChangeAffiliation] = useState(false)
  var update = false
  const [company, setCompany] = useState({
    name: '',
    obj:{
      id: '',
      type: ''
    }
  })
  const [showPassword, setShowPassword] = useState(false)

  const [affiliationSelectOptions, setAffiliationSelectOptions] = useState<{name: string, value: string}[]>([])

  const companyVisible = () => {
    if(form.affiliationLevel === 'distributor') return 'distributor'
    if(form.affiliationLevel === 'organization') return 'charity'
    if(form.affiliationLevel === 'charity') return 'charity'
    if(form.affiliationLevel === 'location') return 'location'
    return ''
  }

  const isUpdate = () => {
    return update
  }

  const statusOptions = [
    {label: userStatus.active, value: userStatus.active},
    {label: userStatus.inactive, value: userStatus.inactive},
  ]


  useEffect(() => {
    (async () => {
      const affiliationsList = await getAffiliationOptions()
      setAffiliationSelectOptions(affiliationsList)
    })()
    
    if(id) {
      (async () => {
        const res = await getUserById({id})
        setForm({
          affiliationLevel: res.affiliationLevel || '',
          firstName: res.firstName || '',
          middleName: res.middleName || '',
          lastName: res.lastName || '',
          status: res.status,
          email: res.email || '',
          encryptedPassword: '',
          roles: res.roles && res.roles.length > 0 ? res.roles.map(role => parseInt(role)): [],
          company: res.company || '',
        })
        if(res.company && (res.charityId || res.locationId || res.distributorId)) {
          setCompany({
            name: res.company,
            obj: {
              id: res.charityId || res.locationId || res.distributorId || '',
              type: ''
            }
          })
        }
        setPhone(res.phone)
        getRolesOptions(res.affiliationLevel)
        isStarting = false
      })()
    }
  },[])

  useEffect(() => {
    update = true
    if (companyVisible())
      setChangeAffiliation(true)
    if(!isStarting) getRolesOptions()
    update = false
  }, [form.affiliationLevel])

  useEffect(() => {
    setChangeAffiliation(false)
  }, [changeAffiliation])

  useEffect(() => {
    console.log(`Company changes ${JSON.stringify(company)}`)
  }, [company])

  const getRolesOptions = async (filter?: string) => {
    if(filter === undefined && form.affiliationLevel === '') {
      setRoles([])
      return
    }
    const res = await getRolesList({filter: filter || form.affiliationLevel})
    setRoles(res.list)
  }

  const onFormChange = (name: string, value: any) => {
    console.log('onFormChange')
    if(name === 'affiliationLevel') {
      setCompany({
        name: '',
        obj: {
          id: '',
          type: ''
        }
      })
      if(typeof value !== 'undefined') {
        if(value.value == null) {
          setForm({
            ...form,
            affiliationLevel: value
          })
        } else {
          setForm({
            ...form,
            affiliationLevel: value.value
          })
        }
      }
    } else {
      setForm({
        ...form,
        [name]: value
      })
    }
    update = false
  }

  const submit = async () => {
    if(!form.affiliationLevel) return notificationError('Please insert an affiliation')
    if(!form.firstName || !form.lastName || onlySpaces(form.firstName) || onlySpaces(form.lastName)) return notificationError('Please insert a valid name') 
    if(!validateEmail(form.email)) return notificationError('Please insert a valid email')
    if(!validatePhone(phone)) return notificationError('Please insert a valid phone number')
    const phonetest = onlyNumbersAsString(phone)
    if(phonetest.length < 10 || phonetest.length > 10 ) return notificationError('Phone must be 10 numbers')
    if(!form.encryptedPassword && !id) return notificationError('Please insert a password')
    if((form.encryptedPassword.length < 6 && !id) || (id && form.encryptedPassword && form.encryptedPassword.length < 6)) return notificationError('Password is too short (minimum is 6 characters)')
    if(form.encryptedPassword.length > 128 ) return notificationError('Password is too long (max is 128 characters)')
    if(passwordConfirm !== form.encryptedPassword && !id) return notificationError('Please confirm your password')
    if(passwordConfirm !== form.encryptedPassword) return notificationError("Can't edit an account by entering two different passwords.")
    if(form.roles.length === 0) return notificationError('Please insert a access level')
    if(companyVisible() && !validSearch && !id) return notificationError('Please enter a valid company')
    if(companyVisible() && !company?.obj?.id && !id) return notificationError('Please enter a valid company')
    if(companyVisible() && (!company?.obj?.type || company?.obj?.type === '')&& !id) return notificationError('Please enter a valid company')

    let payload = {
      ...form,
      phone
    }
    if(companyVisible() && company.name) {
      payload = {
        ...payload,
        company: company.name,
        [`${companyVisible()}Id`]:  company.obj.id
      }
    }
    let validated = false
    if(!id) validated = await createOrUpdateUser(payload)
    if(id) validated = await createOrUpdateUser({id, ...payload})
    if(validated) history(-1)
  }

  return (
      <div className="new-account">
        <Head title="New Account"/>
        <div className="new-account__container">
          <Divider orientation="left"><strong>Affiliations</strong></Divider>
          <div className="new-account__container__row">
            <SelectInput
                options={affiliationSelectOptions}
                label='Affiliation*'
                onSelectChange={(e) =>
                  {
                    onFormChange('affiliationLevel', e)
                  }
                }
                value={form.affiliationLevel}
                disabled={id ? true : false}
                innerProps={{id: 'new-account-affiliation'}}
                selectOnEnter={true}
            />
            {
                isUpdate() &&
                (
                    <p>Loading...</p>
                )
            }
            {companyVisible() && (!id || id === "") && !isUpdate() && !changeAffiliation &&
                (
                    <SmartSearch
                        status="active"
                        onChange={(e: string) => setCompany({...company, name: e})}
                        searchBy={[companyVisible()]}
                        onValidSearch={(e) => setValidSearch(e)}
                        onObjValueChange={(e) => setCompany({...company, obj: e})}
                        value={company.name}
                        triggerWith={company.name}
                        disabled={id ? true : false}
                        label='Company*'
                        innerProps={{id: 'new-account-company'}}
                    />
                )}
            {companyVisible() && (id && id !== "") &&
                (
                    <Input
                        label="Company"
                        placeholder="Company"
                        value={company.name}
                        onChange={(e: any) => {
                        }}
                        innerProps={{id: 'new-account-company'}}
                        disabled={true}
                    />
                )}
          </div>

          <Divider orientation="left"><strong>Name</strong></Divider>

          <div className="new-account__container__row">
            <Input
                onChange={(e: any) => onFormChange('firstName', e.target.value)}
                value={form.firstName}
                label='First Name*'
                placeholder="First Name"
                innerProps={{id: 'new-account-first-name'}}
            />
            <Input
                onChange={(e: any) => onFormChange('middleName', e.target.value)}
                value={form.middleName}
                label='Middle Name'
                placeholder='Middle Name'
                innerProps={{id: 'new-account-middle-name'}}
            />
            <Input
                onChange={(e: any) => onFormChange('lastName', e.target.value)}
                value={form.lastName}
                label='Last Name*'
                placeholder='Last Name'
                innerProps={{id: 'new-account-last-name'}}
            />
          </div>

          <Divider orientation="left"><strong>Status</strong></Divider>

          <div className="new-account__container__row">
            <Radio
                innerProps={{id: 'new-account-status'}}
                label='Status*'
                value={form.status}
                onChange={(e) => onFormChange('status', e.target.value)}
                options={statusOptions}
            />
          </div>

          <Divider orientation="left"><strong>Contacts</strong></Divider>

          <div className="new-account__container__row">
            <Input
                onChange={(e: any) => onFormChange('email', e.target.value)}
                value={form.email}
                label='Email*'
                placeholder='Email'
                innerProps={{id: 'new-account-email'}}
            />
            <Input
                onChange={(e) => setPhone(e.target.value)}
                label='Phone*'
                placeholder='(000) 000-0000'
                value={phone || ''}
                inputMode={InputMode.PHONE}
                innerProps={{id: 'new-account-phone'}}
            />
          </div>

          <Divider orientation="left"><strong>Password</strong></Divider>

          <div className="new-account__container__row">
            <Input
                onChange={(e: any) => onFormChange('encryptedPassword', e.target.value)}
                value={form.encryptedPassword}
                label='Password*'
                placeholder='Password'
                inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
                innerProps={{id: 'new-account-password'}}
            />
            <Input
                onChange={(e: any) => setPasswordConfirm(e.target.value)}
                value={passwordConfirm}
                label='Password Confirmation*'
                placeholder='Password Confirmation'
                inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
                innerProps={{id: 'new-account-password-confirm'}}
            />
            <Button style={{width: 30, display: 'block'}} onClick={() => setShowPassword((prevState) => !prevState)}>
              {!showPassword &&
                  <EyeInvisibleOutlined/>
              }
              {showPassword &&
                  <EyeTwoTone/>
              }
            </Button>
          </div>

          <Divider orientation="left"><strong>Screen Access Level</strong></Divider>

          <div className="new-account__container__row">

            <CheckboxGroup
                onChange={(e: any) => onFormChange('roles', e)}
                options={form.affiliationLevel ? roles : []}
                checkboxName="roleName"
                value={form.roles}
            />
          </div>

        </div>
        <div className="new-account__controls">
          <Divider/>
          <CancelButton/>
          <Button type="primary" onClick={() => submit()}>
            <p id="save-button">Save</p>
          </Button>
        </div>
      </div>
  )
}

export default NewAccount
